import { Container, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import { FilterTile } from './FilterTile';
import { DateRangeFilter } from './DateRangeFilter';
import { TravelersFilter } from './TravelersFilter';
import { TransportFilter } from './TransportFilter';
import { DestinationFilter } from './DestinationFilter';
import { Button } from 'components/Button';
import { SearchIcon } from '@chakra-ui/icons';

const FILTERS = {
  LEAVING_FROM: 'leaving_from',
  DESTINATION: 'destination',
  DATES: 'DATES',
  TRAVELERS: 'travelers',
  TRANSPORT: 'transport',
};

const TripPacksFilters = () => {
  const [activeFilter, setActiveFilter] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [filters, setFilters] = useState({});

  const onSearch = () => {};

  return (
    <Container
      display='flex'
      borderRadius='100px'
      alignItems='center'
      backgroundColor='rgba(249, 249, 249, 0.25)'
      boxShadow='0px 20px 25px -5px rgba(151, 151, 151, 0.1), 0px 10px 10px -5px rgba(151, 151, 151, 0.04)'
      maxW='container.xl'
      marginBottom='60px'
      justifyContent='space-between'
      padding={0}
      gap={2}
    >
      <FilterTile
        onOpen={setActiveFilter}
        title='Leaving From'
        active={activeFilter === FILTERS.LEAVING_FROM}
        subtitle='Search destination'
      >
        <DestinationFilter placeholder='Leaving from' onChange={(value) => setFilters({ [FILTERS.LEAVING_FROM]: value })} />
      </FilterTile>
      <FilterTile onOpen={setActiveFilter} title='Going to' active={activeFilter === FILTERS.DESTINATION} subtitle='Where?'>
        <DestinationFilter placeholder='Going to' onChange={(value) => setFilters({ [FILTERS.DESTINATION]: value })} />
      </FilterTile>
      <FilterTile onOpen={setActiveFilter} title='Dates' active={activeFilter === FILTERS.DATES} subtitle='When?'>
        <DateRangeFilter onChange={(value) => setFilters({ [FILTERS.DATES]: value })} />
      </FilterTile>
      <FilterTile
        onOpen={setActiveFilter}
        title='Travelers'
        active={activeFilter === FILTERS.TRAVELERS}
        subtitle='How many?'
      >
        <TravelersFilter onChange={(value) => setFilters({ [FILTERS.TRAVELERS]: value })} />
      </FilterTile>
      <FilterTile
        onOpen={setActiveFilter}
        title='Transport'
        active={activeFilter === FILTERS.TRANSPORT}
        subtitle='What will you travel on?'
      >
        <TransportFilter onChange={(value) => setFilters({ [FILTERS.TRANSPORT]: value })} />
      </FilterTile>
      <Flex justifyContent='center' paddingLeft='20px' paddingRight='20px'>
        <Button label='Search' onClick={onSearch} variant='solid' size='lg' colorScheme='blue' icon={<SearchIcon />} />
      </Flex>
    </Container>
  );
};

export { TripPacksFilters };
